module.exports = __webpack_public_path__ + "static/media/jobsOpportunitiesPic.3ec1a5ac.webp";